var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AConfigProvider',{attrs:{"locale":_vm.locale}},[_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }